<template>
  <div class="bg-white vform position-relative">
    <div v-show="loading" class="load-bg">
      <span v-show="loading">
        <i class="spin ml-4" />
      </span>
    </div>
    <div class="row m-4 justify-content-center">
      <div class="col-lg-9 bg-white py-4">
        <div class="mt-4">
          <h1>{{ $t('message.orderHistory') }}</h1>
        </div>
        <hr />
        <div class="container">
          <div v-for="(order, index) in pageOrders" :key="index" class="row">
            <div class="row col-sm-12 order-items">
              <div class="order-item-details col-sm-9">
                <div
                  class="color-gray fdate"
                  v-html="parseDate(order.ScheduledTime, order.StoreName)"
                />
                <ul>
                  <li
                    v-for="(orderItem, index) in order.OrderItems"
                    :key="index"
                  >{{ orderItem.Quantity }} x {{ orderItem.Name }}</li>
                </ul>
              </div>
              <div class="col-sm-3">
                <div class="row order-item-cost text-left padding-5-left">
                  <span>{{ (order.TotalExcludingTax + order.TotalTax) | formatMoney }}</span>
                </div>
                <div class="row w-100">
                  <button
                    type="button"
                    :style="desktopStyles.btn"
                    class="btn btn-primary btn-with-margins"
                    :disabled="IsStoreClose"
                    @click="showReorderConfirm(order)"
                  >{{ $t('message.reorder') }}</button>
                  <button
                    v-if="showActiveOrderLink(order)"
                    type="button"
                    class="btn btn-primary btn-with-margins"
                    @click="showComplateOrderPage(order)"
                  >{{ $t('message.view') }}</button>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <hr />
            </div>
          </div>
          <div v-if="pageOrders.length == 0">
            <message message="No order available" />
          </div>
        </div>
        <div class="order-pagination">
          <pagination
            v-model="page"
            :records="records"
            :per-page="perPage"
            :options="options"
            @paginate="paginateCallback"
          />
        </div>
      </div>
    </div>
    <confirm
      v-if="showConfirm"
      ref="reorderConfirm"
      :modal-title="'Delete Card'"
      :proccessing="reordering"
      @confirmed="reorder"
      @close="closeConfirm"
    >
      <template slot="body">
        <p>{{ $t('message.reorderCurrentOrder') }} ?</p>
      </template>
    </confirm>
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import confirm from "../confirm.vue";
import shared from "../../sharedscripts/user/OrderHistory.js";
import Message from "./../shared/Message";
import { mapGetters } from "vuex";
export default {
  components: {
    Pagination,
    Message,
    confirm
  },
  data() {
    return {
      page: 1,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      storeClosed: false,
      showConfirm: false,
      reordering: false,
      selectedOrder: {}
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "currentStoreDoc"])
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...shared.methods
  }
};
</script>